import PropTypes from 'prop-types';
import { createContext, useState, useEffect } from 'react';
// hooks
import useResponsive from '../shared/hooks/useResponsive';

// ----------------------------------------------------------------------

const initialState = {
  collapseClick: false,
  collapseHover: false,
  onToggleCollapse: () => {},
  onHoverEnter: () => {},
  onHoverLeave: () => {},
};

const CollapseDrawerContext = createContext(initialState);

// ----------------------------------------------------------------------

CollapseDrawerProvider.propTypes = {
  children: PropTypes.node,
};

function CollapseDrawerProvider({ children }) {
  const isDesktop = useResponsive('up', 'lg');
  const [collapseClick, setCollapseClick] = useState(false);
  const [collapseHover, setCollapseHover] = useState(false);

  const onToggleCollapse = () => {
    setCollapseClick(!collapseClick);
  };

  const onHoverEnter = () => {
    if (collapseClick) {
      setCollapseHover(true);
    }
  };

  const onHoverLeave = () => {
    setCollapseHover(false);
  };

  useEffect(() => {
    if (!isDesktop) {
      setCollapseClick(false);
    }
  }, [isDesktop]);

  return (
    <CollapseDrawerContext.Provider
      value={{
        collapseClick,
        collapseHover,
        onToggleCollapse,
        onHoverEnter,
        onHoverLeave,
      }}
    >
      {children}
    </CollapseDrawerContext.Provider>
  );
}

export { CollapseDrawerProvider, CollapseDrawerContext };
